import { create } from 'zustand';
import { V1PreviewTradeFeeResponse } from '@fintronners/react-api/src';

type State = {
  loading: boolean;
  error: Error | null;
  data: V1PreviewTradeFeeResponse | null;
};

type Actions = {
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  setData: (data: V1PreviewTradeFeeResponse | null) => void;
  reset: () => void;
};

const initialState: State = {
  loading: false,
  error: null,
  data: null,
};

export const usePreviewTradeFeeStore = create<State & Actions>((set) => ({
  ...initialState,
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setData: (data) => set({ data }),
  reset: () => set(initialState),
}));
